import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserInfo } from "../store/auth/selectors";
import { CONFIG_VARS } from "../constants/configuration";
const CareerCounselingPage = () => {
  const [surveyLink, setSurveyLink] = useState("");
  const userData = useSelector(getUserInfo);
  const [isIframeLoad, setIframeLoading] = useState(false);

  useEffect(() => {
    if (userData?.crn_id) {
      const baseUrl =
        CONFIG_VARS.environment === "production"
          ? "https://survey.zohopublic.in/zs/k0BoS3"
          : "https://survey.zohopublic.in/zs/00BcqW";
      const constructedLink = `${baseUrl}?ID=${userData.crn_id}`;
      setSurveyLink(constructedLink);
    }
  }, [userData]);

  // Message listener for iframe redirection
  useEffect(() => {
    const handleMessage = (event) => {
      const environmentOrigins = {
        production: "https://genius.infinitylearn.com",
        prepord: "https://genius.devinfinitylearn.in"
      };

      let expectedOrigin = window.location.origin;

      if (CONFIG_VARS.environment === "production" || CONFIG_VARS.environment === "prepord") {
        expectedOrigin = environmentOrigins[CONFIG_VARS.environment];
      }

      if (event.origin !== expectedOrigin) {
        return;
      }

      if (event.data?.type === "iframeRedirectInmobius" && event.data.product && event.data.task) {
        const { product, task } = event.data;
        const redirectUrl = `${window.location.origin}/redirection?product=${product}&task=${task}`;
        window.location.href = redirectUrl;
      }
    };

    window.addEventListener("message", handleMessage, false);

    return () => {
      window.removeEventListener("message", handleMessage, false);
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "calc(100vh - 80px)"
      }}
    >
      {surveyLink && (
        <>
          {!isIframeLoad && (
            <p
              style={{
                position: "absolute",
                zIndex: 1,
                background: "white",
                padding: "1rem",
                borderRadius: "8px"
              }}
            >
              Loading...
            </p>
          )}
          <iframe
            src={surveyLink}
            title="Career Counseling Form"
            width="100%"
            height="100%"
            style={{ border: "none", display: "block" }}
            onLoad={() => setIframeLoading(true)}
          />
        </>
      )}
    </div>
  );
};

export default CareerCounselingPage;
